<template>
    <div class="app">
      <img class="bg_wrap" src="./../../assets/img/bg0.jpg" mode='scaleToFill'>
      <div class="title_wrap">
        <img src="./../../assets/img/luckyDraw_title.png" mode='widthFix'>
      </div>
      <div class="luckyDraw_wrap">
        <div class="content">
          <img class="bg" src="./../../assets/img/lottery_bg.png" mode='scaleToFill'>
          <div class="draw_wrap">
            <draw :list="answerList" @okDraw="okDraw" :drawNum="draw_num" :prize_id="prize_id"  @winTispFn="winTispFn"></draw>
          </div>
        </div>
      </div>
      <!-- <button class="recording_btn" @getuserinfo="recordingFn" open-type="getUserInfo"><img src="./../../assets/img/recording.png" mode='widthFix'></button> -->
      <button class="recording_btn" @touchend="recordingFn"><img src="./../../assets/img/recording.png" mode='widthFix'></button>
      <!-- <div class="recording_btn" @click="recordingFn">
        <img src="./../../assets/img/recording.png" mode='widthFix'>
      </div> -->
      <recording v-if="isRecording" @closeClick="recordingFn"></recording>
      <winningInfo v-if="isWinnig" @closeClick="winFn" :is_award="is_award"></winningInfo><!-- v-if="isWinnig"-->
      <caiRegister v-if="isRegister"></caiRegister>
    </div>
</template>
<script>
import draw from '@/components/draw'
import recording from '@/components/recording'
import winningInfo from '@/components/winningInfo'
import caiRegister from '@/components/register';//引入登陆组件
import { fail } from 'assert';
export default {
  data () {
    return {
      isRegister: false,
      isRecording: false,
      isWinnig: false,
      isSetInfo: false,
      draw_num: 1,
      prize_id:'',
      answerList: [
        // {
        //   img: './../../assets/img/draw_img1.png',
        //   id:1
        // },
        // {
        //   img: './../../assets/img/draw_img2.png',
        //   id:2
        // },
        // {
        //   img: './../../assets/img/draw_img1.png',
        //   id:3
        // },
        // {
        //   img: './../../assets/img/draw_img2.png',
        //   id:4
        // },
        // {
        //   img: './../../assets/img/draw_img1.png',
        //   id:5
        // },
        // {
        //   img: './../../assets/img/draw_img2.png',
        //   id:6
        // },
        // {
        //   img: './../../assets/img/draw_img1.png',
        //   id:7
        // },
        // {
        //  img: './../../assets/img/draw_img2.png',
        //   id:18
        // }
      ],
      is_award: 2
    }
  },
  components: {
    draw,
    recording,
    winningInfo,
    caiRegister
  },
  created(){
   
  },
  beforeMount(){
    
  },
  mounted(){
    this.draw_num = 1;
    this.prize_id = window.localStorage.getItem('prize_id');
    this.getData();
  },
  methods:{
    getData(){
      this.$http.get(`${this.service}questionnaire/award`)
      .then(res=>{
        console.log(res)
        let json = JSON.stringify(res);
        // 替换所有以“/uploads/”或其他开头的内容（一般情况下为图片路径的开头），给前面添加 api 根域名
        json = json.replace(/"\/(uploads|img|ueditor)\//g, '"' + 'http://con2.txzfw.kcshop.vip' + '/$1/');
        this.answerList = JSON.parse(json)
        console.log(this.answerList,555)
      })

    },
    okDraw(){
      this.draw_num--
    },
    recordingFn(){
      this.isRecording = !this.isRecording
    },
    getUserFn(res){
        let data = res.mp.detail;
        if(data.errMsg == 'getUserInfo:ok'){
            this.isRecording = !this.isRecording
        }else{
            this.$refs.caiToast.showFu({
                 msg:'请先授权在进行操作',
                 time:1500
            })
        }
    },
    winFn(){
      this.isWinnig = !this.isWinnig
      if(this.is_award==1){
        setTimeout(() => {
          // this.isRegister = true;
        }, 150);
      }
    },
    winTispFn(e){
      this.is_award = e.is_award
      this.isWinnig = true
    }
  },
  onLoad() {
    Object.assign(this.$data, this.$options.data())//重置data初始化
  },
  onShareAppMessage(){//自定义转发
      return {
        title: '平安有我 民意收集',
        path: '/pages/index/main'
      }
    }
}
</script>

<style scoped lang="less">
.app{
  min-height: 100vh;
  position: relative;
  .bg_wrap{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  }
  .title_wrap{
    height: 1.01rem;
    margin: 0 auto;
    text-align: center;
    position: relative;
    padding-top: 1.28rem;
    padding-bottom:.59rem;
    img{
     width: 4.83rem;
     height: 1.01rem;
     display: inline-block;
     
    }
  }
  .luckyDraw_wrap{

    .opportunity{
      width: 4.8rem;
      font-size: .28rem;
      color: #ffffff;
      background: #49b87f;
      line-height: .7rem;
      border-radius: 50px;
      text-align: center;
      letter-spacing: 1em;
      margin: 0 auto;
      span{
        color: #fcfa64;
        font-size: .42rem;
      }
    }
    .content{
      width: 5.82rem;
      height: 4.94rem;
      margin: 0 auto;
      position: relative;
      .bg{
        width: 5.82rem;
        height: 4.94rem;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
      .draw_wrap{
        padding: .35rem .3rem;
        position: relative;
        z-index: 2;
      }
    }
  }
  .recording_btn{
    width: 2.4rem;
    height: .72rem;
    position: relative;
    margin: .69rem auto 0;
    padding: 0;
    border: none;
    background-color: transparent;
    box-shadow:none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    img{
      width: 2.4rem;
    height: .72rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/luckDraw/index.vue